{
  "pages": {
    "listTitle": "Nhân viên",
    "addTitle": "Thêm nhân viên",
    "editTitle": "Sửa nhân viên",
    "detailsTitle": "Chi tiết nhân viên",
    "permissionDenied": "Bạn không có quyền xem nhân viên.",
    "createPermissionDenied": "Bạn không có quyền thêm nhân viên.",
    "updatePermissionDenied": "Bạn không có quyền cập nhật nhân viên."
  },
  "avatar": {
    "title": "Ảnh đại diện nhân sự",
    "hint": "JPEG hoặc PNG, tối đa 10MB. Ảnh sẽ được cắt vuông trước khi lưu. Ảnh chính thức do HR quản lý.",
    "hintShort": "JPEG, PNG. Tối đa 10MB.",
    "upload": "Tải ảnh",
    "change": "Đổi ảnh",
    "remove": "Xóa ảnh",
    "cropTitle": "Cắt ảnh nhân sự",
    "cropHint": "Kéo để căn vùng hiển thị. Ảnh sẽ được lưu dạng vuông.",
    "cropZoom": "Thu phóng",
    "cropCancel": "Hủy",
    "cropConfirm": "Lưu ảnh",
    "uploadSuccess": "Đã cập nhật ảnh nhân sự",
    "uploadDisplayFailed": "Đã lưu ảnh nhưng không hiển thị được — thử tải lại trang",
    "uploadFailed": "Không thể tải ảnh lên",
    "removeSuccess": "Đã xóa ảnh nhân sự",
    "removeFailed": "Không thể xóa ảnh nhân sự"
  },
  "status": {
    "active": "Đang làm việc",
    "inactive": "Ngừng",
    "on_leave": "Nghỉ phép",
    "terminated": "Đã nghỉ việc"
  },
  "departments": {
    "board": "Ban Giám đốc",
    "marketing": "Marketing",
    "reception": "Lễ tân",
    "assistant": "Phụ tá",
    "doctor": "Bác sĩ điều trị",
    "housekeeping": "Bếp, vệ sinh",
    "administrator": "Administrator",
    "accounting": "Kế toán"
  },
  "employeeTypes": {
    "full_time": "Toàn thời gian",
    "part_time": "Bán thời gian",
    "intern": "Thực tập"
  },
  "employmentStages": {
    "probation": "Thử việc",
    "probationUntil": "Thử việc (đến {{date}})",
    "confirmed": "Chính thức",
    "not_applicable": "Không áp dụng"
  },
  "gender": {
    "male": "Nam",
    "female": "Nữ",
    "other": "Khác"
  },
  "specializations": {
    "General Dentistry": "Nha khoa tổng quát",
    "Orthodontics": "Chỉnh nha",
    "Implant / Oral Surgery": "Implant / Phẫu thuật miệng",
    "Periodontics": "Nha chu",
    "Pediatric Dentistry": "Nha khoa trẻ em",
    "Prosthodontics": "Phục hình",
    "Endodontics": "Nội nha",
    "Cosmetic Dentistry": "Nha khoa thẩm mỹ"
  },
  "relationships": {
    "spouse": "Vợ/Chồng",
    "parent": "Cha/Mẹ",
    "child": "Con",
    "sibling": "Anh/Chị/Em",
    "relative": "Họ hàng",
    "friend": "Bạn",
    "colleague": "Đồng nghiệp",
    "other": "Khác"
  },
  "fields": {
    "staffCode": "Mã NV",
    "firstName": "Tên nhân viên",
    "lastName": "Họ & Chữ lót",
    "email": "Email",
    "phone": "Số điện thoại",
    "gender": "Giới tính",
    "dateOfBirth": "Ngày sinh",
    "department": "Phòng ban",
    "designation": "Chức danh",
    "employeeType": "Loại hợp đồng",
    "employmentStage": "Giai đoạn hợp đồng",
    "probationEndsOn": "Ngày hết thử việc",
    "specialization": "Chuyên môn",
    "isDoctor": "Là bác sĩ điều trị",
    "isAssistant": "Là phụ tá",
    "status": "Trạng thái",
    "terminatedOn": "Ngày nghỉ việc",
    "joinDate": "Ngày vào làm",
    "address": "Địa chỉ",
    "street": "Địa chỉ (Số nhà, Tên đường)",
    "province": "Tỉnh/Thành phố",
    "ward": "Phường/Xã",
    "bio": "Giới thiệu",
    "primaryClinics": "Chi nhánh chính",
    "leaveApprovers": "Người duyệt phép",
    "leaveFollowers": "Người theo dõi đơn phép",
    "payrollApprovers": "Người duyệt tạm ứng",
    "payrollFollowers": "Người theo dõi tạm ứng",
    "attendanceApprovers": "Người duyệt chấm công",
    "weeklyTemplate": "Mẫu lịch",
    "emergencyContact": "Liên hệ khẩn cấp",
    "emergencyContactN": "Liên hệ khẩn cấp {{n}}",
    "emergencyName": "Tên người liên hệ",
    "emergencyPhone": "SĐT người liên hệ",
    "emergencyRelationship": "Mối quan hệ",
    "staffType": "Loại nhân viên",
    "createAccount": "Tạo tài khoản đăng nhập",
    "username": "Tên đăng nhập",
    "temporaryPassword": "Mật khẩu tạm",
    "accountRole": "Loại tài khoản",
    "permissionGroup": "Vai trò",
    "passwordSet": "Đã đặt mật khẩu tạm"
  },
  "tabs": {
    "overview": "Tổng quan",
    "schedule": "Lịch làm việc",
    "attendance": "Chấm công",
    "timeOff": "Nghỉ phép",
    "payslips": "Phiếu lương",
    "commission": "Hoa hồng",
    "journal": "Nhật ký điều trị",
    "contact": "Liên hệ",
    "professional": "Chuyên môn",
    "activity": "Hoạt động"
  },
  "ariaActions": "thao tác",
  "table": {
    "name": "Họ tên",
    "staffName": "Họ tên nhân viên",
    "code": "Mã",
    "staffCode": "Mã NV",
    "department": "Phòng ban",
    "designation": "Chức danh",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "designationDepartment": "Chức danh / Phòng ban",
    "contact": "Thông tin liên hệ",
    "linkedAccount": "Tài khoản đăng nhập",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "updatedBy": "Người chỉnh sửa"
  },
  "actions": {
    "add": "Thêm nhân viên",
    "adding": "Đang thêm nhân viên...",
    "next": "Tiếp tục",
    "closeDialog": "Đóng",
    "edit": "Sửa",
    "editUser": "Chỉnh sửa tài khoản",
    "delete": "Xóa",
    "view": "Xem",
    "save": "Lưu",
    "cancel": "Hủy",
    "refresh": "Làm mới",
    "back": "Quay lại",
    "update": "Cập nhật nhân viên",
    "updating": "Đang cập nhật nhân viên...",
    "deleting": "Đang xóa...",
    "backToStaff": "Quay lại nhân viên",
    "selectWeeklyTemplate": "Gán lịch",
    "addEmergencyContact": "Thêm liên hệ",
    "removeEmergencyContact": "Xóa liên hệ",
    "moreActions": "Thêm thao tác",
    "export": "Xuất file",
    "import": "Nhập file"
  },
  "picker": {
    "noResults": "Không tìm thấy nhân viên",
    "clearAssignee": "Bỏ gán"
  },
  "filters": {
    "search": "Tìm nhân viên",
    "department": "Phòng ban",
    "employeeType": "Loại hợp đồng",
    "status": "Trạng thái",
    "allDepartments": "Tất cả phòng ban",
    "allEmployeeTypes": "Tất cả loại hợp đồng",
    "allStatuses": "Tất cả trạng thái",
    "title": "Bộ lọc nhân viên",
    "searchPlaceholder": "Tìm theo mã, tên, email, điện thoại...",
    "practitionerType": "Loại nhân viên",
    "allPractitionerTypes": "Tất cả loại"
  },
  "staffTypes": {
    "doctor": "Bác sĩ điều trị",
    "assistant": "Phụ tá",
    "other": "Nhân viên khác"
  },
  "empty": "Không tìm thấy nhân viên",
  "dialogs": {
    "deleteConfirm": "Bạn có chắc muốn xóa nhân viên này?",
    "deleteTitle": "Xóa nhân viên",
    "deleteMessage": "Bạn có chắc muốn xóa {{name}}? Thao tác này không thể hoàn tác.",
    "thisStaffMember": "nhân viên này",
    "deleteWindowConfirm": "Xóa {{name}}? Thao tác này không thể hoàn tác.",
    "importTitle": "Nhập nhân viên"
  },
  "validation": {
    "firstNameRequired": "Vui lòng nhập tên",
    "lastNameRequired": "Vui lòng nhập họ",
    "emailRequired": "Vui lòng nhập email",
    "phoneRequired": "Vui lòng nhập điện thoại",
    "genderRequired": "Vui lòng chọn giới tính",
    "dateOfBirthInvalid": "Ngày sinh phải là ngày hợp lệ và không ở tương lai.",
    "joinDateBeforeDob": "Ngày vào làm không được trước ngày sinh.",
    "departmentRequired": "Vui lòng chọn phòng ban",
    "designationRequired": "Vui lòng nhập chức danh",
    "employeeTypeRequired": "Vui lòng chọn loại hợp đồng",
    "primaryClinicsRequired": "Vui lòng chọn chi nhánh chính",
    "specializationRequiredForDentists": "Vui lòng chọn chuyên môn cho bác sĩ nha khoa",
    "specializationInvalid": "Vui lòng chọn chuyên môn hợp lệ",
    "fixHighlightedFields": "Vui lòng sửa các trường được đánh dấu",
    "usernameRequired": "Vui lòng nhập tên đăng nhập",
    "temporaryPasswordRequired": "Vui lòng nhập mật khẩu tạm",
    "permissionGroupRequired": "Vui lòng chọn vai trò",
    "terminatedOnRequired": "Vui lòng chọn ngày nghỉ việc",
    "terminatedOnFutureWhileTerminated": "Ngày nghỉ việc trong tương lai thì giữ trạng thái Đang làm việc. Hệ thống sẽ chuyển Đã nghỉ việc vào ngày đó.",
    "terminatedOnBeforeJoin": "Ngày nghỉ việc không được trước ngày vào làm."
  },
  "toasts": {
    "loadFailed": "Không tải được danh sách nhân viên",
    "loadClinicsFailed": "Không tải được danh sách phòng khám",
    "loadDetailsFailed": "Không tải được thông tin nhân viên",
    "created": "Đã thêm nhân viên",
    "createdWithName": "Đã thêm {{name}} vào danh sách nhân viên",
    "createdWithAccount": "Đã thêm {{name}} và tạo tài khoản đăng nhập",
    "createFailed": "Thêm nhân viên thất bại",
    "createdAccountFailed": "Không tạo được tài khoản đăng nhập",
    "createdAccountFailedWithReason": "Không tạo được tài khoản đăng nhập: {{reason}}",
    "createdAccountFailedNoOrg": "Không xác định được tổ chức để tạo tài khoản",
    "updated": "Đã cập nhật nhân viên",
    "updatedWithName": "Đã cập nhật thông tin của {{name}}",
    "updateFailed": "Cập nhật thất bại",
    "deleted": "Đã xóa nhân viên",
    "deletedWithAccount": "Đã xóa nhân viên và đóng tài khoản đăng nhập",
    "deleteOwnAccountBlocked": "Không xóa được hồ sơ của chính bạn",
    "deleteFailed": "Xóa thất bại",
    "deleteBlocked": "Không xóa được. Nhân viên còn gắn với: {{items}}.",
    "deleteBlockedRelations": {
      "appointment": "lịch hẹn",
      "treatment": "điều trị",
      "patient": "bệnh nhân giới thiệu",
      "referrer": "người giới thiệu",
      "lead": "lead",
      "payroll": "lương",
      "attendance": "chấm công",
      "leave": "nghỉ phép",
      "schedule": "lịch làm việc",
      "labo": "đơn labo",
      "commission": "hoa hồng",
      "kpi": "KPI",
      "inventory": "kho",
      "task": "công việc",
      "project": "dự án",
      "approver": "danh sách người duyệt"
    },
    "exported": "Đã xuất danh sách nhân viên",
    "exportFailed": "Xuất file thất bại",
    "imported": "Đã nhập danh sách nhân viên",
    "importFailed": "Nhập file thất bại",
    "templateFailed": "Không tải được file mẫu"
  },
  "importExport": {
    "hintRequired": "Bắt buộc: firstName, lastName, gender, phone, departmentCode (mã phòng ban, vd. doctor, reception).",
    "hintDob": "dateOfBirth (ngày sinh) tùy chọn. Format YYYY-MM-DD hoặc DD/MM/YYYY, không ở tương lai. Ngày vào làm không được trước ngày sinh.",
    "hintMatch": "Có mã nhân viên (staffCode, dạng EMP0001) thì khớp theo mã để cập nhật. Không có mã → luôn tạo mới. Không tạo tài khoản đăng nhập.",
    "hintDepartment": "departmentCode là mã phòng ban đã có. Có thể ghi tên phòng ban (vd. Lễ tân).",
    "hintClinics": "clinicBranchCodes: nhiều chi nhánh cách nhau bằng ; hoặc , (vd. HN01; HN02). Trống + đang lọc 1 PK → gán PK đó.",
    "hintRoles": "isDoctor / isAssistant: true/false, 1/0, có/không. Bác sĩ có chức danh chứa dentist bắt buộc specialization (vd. General Dentistry).",
    "hintEmergency": "emergencyContacts: Tên|SĐT|mối quan hệ; nhiều người cách nhau bằng dấu ; (vd. Trần Thị Bình|0987654321|spouse).",
    "hintAccount": "Không nhập user/mật khẩu ở đây. Gán tài khoản sau trên hồ sơ nhân viên.",
    "hintMapping": "Tên cột không cần giống file mẫu — hãy ghép cột sau khi chọn file, rồi bấm Kiểm tra.",
    "hintSheet": "File Excel: chỉ nhập sheet đầu tiên; các sheet khác bị bỏ qua.",
    "chooseFile": "Chọn file CSV hoặc Excel",
    "dropHint": "Nhấn để chọn hoặc kéo thả file CSV hoặc Excel",
    "acceptHint": "CSV hoặc Excel (.xlsx), tối đa 20MB / 20000 dòng. Excel: chỉ đọc sheet đầu.",
    "invalidFile": "Vui lòng chọn file CSV hoặc Excel (.xlsx)",
    "changeFile": "Đổi file",
    "commit": "Nhập dữ liệu",
    "downloadTemplate": "Tải file mẫu",
    "downloadErrors": "Tải dòng lỗi (CSV)",
    "errorsCsvFilename": "nhan-vien-loi.csv",
    "noFile": "Vui lòng chọn file CSV hoặc Excel",
    "previewTitle": "Kết quả kiểm tra",
    "total": "Tổng dòng",
    "toCreate": "Sẽ tạo mới",
    "toUpdate": "Sẽ cập nhật",
    "errorsTitle": "Lỗi",
    "row": "Dòng",
    "code": "Mã",
    "message": "Chi tiết",
    "readyToCommit": "File hợp lệ. Bạn có thể nhập dữ liệu.",
    "hasErrors": "File còn lỗi. Sửa rồi kiểm tra lại trước khi nhập.",
    "resultTitle": "Kết quả nhập",
    "created": "Đã tạo",
    "updated": "Đã cập nhật",
    "uploading": "Đang tải file…",
    "checking": "Đang kiểm tra file…",
    "checkingWithCount": "Đang kiểm tra {{count}} dòng…",
    "importing": "Đang nhập dữ liệu…",
    "importingWithCount": "Đang nhập {{count}} dòng…",
    "confirmUpdateTitle": "Xác nhận cập nhật",
    "confirmUpdateMessage": "Sẽ cập nhật {{count}} hồ sơ nhân viên hiện có. Tiếp tục?",
    "confirmUpdateConfirm": "Cập nhật",
    "fields": {
      "staffCode": "Mã nhân viên",
      "firstName": "Tên",
      "lastName": "Họ",
      "gender": "Giới tính",
      "dateOfBirth": "Ngày sinh",
      "phone": "Số điện thoại",
      "email": "Email",
      "isDoctor": "Bác sĩ điều trị",
      "isAssistant": "Phụ tá",
      "departmentCode": "Mã phòng ban",
      "designation": "Chức danh",
      "employeeType": "Loại hợp đồng",
      "specialization": "Chuyên môn",
      "street": "Địa chỉ",
      "ward": "Phường/xã",
      "wardCode": "Mã phường/xã",
      "province": "Tỉnh/thành",
      "provinceCode": "Mã tỉnh",
      "country": "Quốc gia",
      "joinDate": "Ngày vào làm",
      "probationEndsOn": "Ngày hết thử việc",
      "terminatedOn": "Ngày nghỉ việc",
      "status": "Trạng thái",
      "clinicBranchCodes": "Mã chi nhánh",
      "bio": "Giới thiệu",
      "emergencyContacts": "Liên hệ khẩn cấp"
    },
    "rowErrors": {
      "STAFF_CODE_INVALID": "Mã nhân viên phải bắt đầu bằng EMP, theo sau là chữ hoặc số (tối đa {{max}} ký tự).",
      "DUPLICATE_STAFF_CODE": "Mã nhân viên bị trùng trong file.",
      "FIRST_NAME_REQUIRED": "Thiếu tên (firstName).",
      "FIRST_NAME_TOO_LONG": "Tên không được vượt quá {{max}} ký tự.",
      "LAST_NAME_REQUIRED": "Thiếu họ (lastName).",
      "LAST_NAME_TOO_LONG": "Họ không được vượt quá {{max}} ký tự.",
      "GENDER_INVALID": "Giới tính phải là male, female, other (hoặc Nam / Nữ / Khác).",
      "DOB_INVALID": "Ngày sinh phải là YYYY-MM-DD hoặc DD/MM/YYYY và không ở tương lai.",
      "JOIN_DATE_BEFORE_DOB": "Ngày vào làm không được trước ngày sinh.",
      "PHONE_INVALID": "Số điện thoại không hợp lệ.",
      "EMAIL_INVALID": "Email không hợp lệ.",
      "DUPLICATE_EMAIL": "Email bị trùng trong file.",
      "EMAIL_TAKEN": "Email đã được dùng cho nhân viên khác.",
      "DEPARTMENT_REQUIRED": "Thiếu mã phòng ban (departmentCode).",
      "DEPARTMENT_UNKNOWN": "Không tìm thấy phòng ban {{departmentCode}}.",
      "DEPARTMENT_INACTIVE": "Phòng ban {{departmentCode}} đang ngừng dùng.",
      "STAFF_OUT_OF_SCOPE": "Mã {{staffCode}} thuộc nhân viên ngoài phạm vi phòng khám hiện tại.",
      "IS_DOCTOR_INVALID": "isDoctor phải là true/false, 1/0, hoặc có/không.",
      "IS_ASSISTANT_INVALID": "isAssistant phải là true/false, 1/0, hoặc có/không.",
      "EMPLOYEE_TYPE_INVALID": "Loại hợp đồng phải là full_time, part_time, hoặc intern.",
      "STATUS_INVALID": "Trạng thái phải là active, inactive, on_leave, hoặc terminated.",
      "SPECIALIZATION_INVALID": "Chuyên môn không hợp lệ.",
      "SPECIALIZATION_REQUIRED": "Bác sĩ nha khoa (dentist) bắt buộc có chuyên môn.",
      "JOIN_DATE_INVALID": "Ngày vào làm phải là YYYY-MM-DD hoặc DD/MM/YYYY.",
      "PROBATION_ENDS_ON_INVALID": "Ngày hết thử việc phải là YYYY-MM-DD hoặc DD/MM/YYYY.",
      "BIO_TOO_LONG": "Giới thiệu không được vượt quá {{max}} ký tự.",
      "STREET_TOO_LONG": "Địa chỉ không được vượt quá {{max}} ký tự.",
      "CLINIC_UNKNOWN": "Không tìm thấy mã chi nhánh {{clinicBranchCode}}.",
      "CLINIC_OUT_OF_SCOPE": "Mã chi nhánh {{clinicBranchCode}} nằm ngoài phạm vi phòng khám hiện tại.",
      "CLINIC_INACTIVE": "Mã chi nhánh {{clinicBranchCode}} đang ngừng hoạt động.",
      "EMERGENCY_CONTACTS_LIMIT": "Tối đa 5 liên hệ khẩn cấp.",
      "EMERGENCY_NAME_TOO_LONG": "Tên người liên hệ không được vượt quá {{max}} ký tự.",
      "EMERGENCY_RELATIONSHIP_TOO_LONG": "Mối quan hệ không được vượt quá {{max}} ký tự.",
      "EMERGENCY_PHONE_INVALID": "Số điện thoại người liên hệ không hợp lệ."
    }
  },
  "errors": {
    "authTokenMissing": "Không tìm thấy token xác thực"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  },
  "helper": {
    "staffCodeAuto": "Tự động cấp khi tạo nhân viên",
    "probationEndsOn": "Để trống nếu đã chính thức. Nhân viên full-time mới mặc định 60 ngày sau ngày vào làm.",
    "terminatedOn": "Ngày đầu tiên không còn làm việc. Ngày tương lai thì giữ trạng thái Đang làm việc — hệ thống chuyển Đã nghỉ việc vào ngày đó.",
    "weeklyTemplate": "Để trống = chưa cấu hình mẫu lịch. Nếu chọn mẫu và nhân viên chỉ có đúng 1 phòng khám chính, hệ thống sẽ tự gán lịch cho PK đó. Nhiều PK → gán sau trên mẫu lịch.",
    "leaveApprovers": "Để trống = dùng người duyệt của phòng ban. Gán trên hồ sơ sẽ ghi đè. Người đầu tiên là mặc định. Chỉ chọn nhân sự đang hoạt động và đã có tài khoản đăng nhập.",
    "leaveFollowers": "Cộng dồn với người theo dõi của phòng ban. Để trống nếu không cần thêm. Chỉ chọn nhân sự đang hoạt động và đã có tài khoản đăng nhập.",
    "payrollApprovers": "Để trống = dùng người duyệt tạm ứng của phòng ban. Gán trên hồ sơ sẽ ghi đè. Chỉ chọn nhân sự đang hoạt động và đã có tài khoản đăng nhập.",
    "payrollFollowers": "Cộng dồn với người theo dõi tạm ứng của phòng ban. Để trống nếu không cần thêm. Chỉ chọn nhân sự đang hoạt động và đã có tài khoản đăng nhập.",
    "attendanceApprovers": "Để trống = dùng người duyệt chấm công của phòng ban. Gán trên hồ sơ sẽ ghi đè. Chỉ chọn nhân sự đang hoạt động và đã có tài khoản đăng nhập.",
    "createAccount": "Bỏ chọn nếu chỉ tạo hồ sơ nhân sự, chưa cần đăng nhập.",
    "temporaryPassword": "Người dùng sẽ phải đổi mật khẩu này khi đăng nhập lần đầu."
  },
  "placeholders": {
    "lastName": "Nhập họ và chữ lót",
    "firstName": "Nhập tên",
    "email": "email@example.com",
    "phone": "Ví dụ: 0901234567",
    "designation": "Lễ tân",
    "selectGender": "Chọn giới tính",
    "dateOfBirth": "DD/MM/YYYY",
    "selectDepartment": "Chọn phòng ban",
    "selectEmployeeType": "Chọn loại hợp đồng",
    "selectSpecialization": "Chọn chuyên môn",
    "selectRelationship": "Chọn mối quan hệ",
    "selectPrimaryClinics": "Chọn chi nhánh",
    "selectStatus": "Chọn trạng thái",
    "selectPractitionerType": "Chọn loại nhân viên",
    "noWeeklyTemplate": "Không áp dụng",
    "street": "Số nhà, tên đường",
    "province": "Chọn tỉnh/thành phố",
    "ward": "Chọn phường/xã",
    "emergencyName": "Nguyễn Văn Bình",
    "emergencyPhone": "Ví dụ: 0901234567",
    "bio": "Giới thiệu ngắn về nhân viên",
    "searchLeaveApprovers": "Tìm nhân sự duyệt phép",
    "searchLeaveFollowers": "Tìm nhân sự theo dõi đơn",
    "searchPayrollApprovers": "Tìm nhân sự duyệt tạm ứng",
    "searchPayrollFollowers": "Tìm nhân sự theo dõi tạm ứng",
    "searchAttendanceApprovers": "Tìm nhân sự duyệt chấm công",
    "username": "Nhập tên đăng nhập",
    "temporaryPassword": "Nhập mật khẩu tạm",
    "selectAccountRole": "Chọn loại tài khoản",
    "selectPermissionGroup": "Chọn vai trò"
  },
  "sections": {
    "additionalInformation": "Thông tin bổ sung",
    "personal": "Cá nhân",
    "job": "Công việc",
    "review": "Xem lại",
    "account": "Tài khoản",
    "personalInfo": "Thông tin cá nhân",
    "jobInfo": "Thông tin công việc",
    "accountInfo": "Thông tin tài khoản",
    "leave": "Nghỉ phép",
    "weeklyTemplateOptional": "Mẫu lịch (tùy chọn)",
    "contact": "Liên hệ",
    "employment": "Công việc",
    "about": "Giới thiệu",
    "professionalInformation": "Thông tin chuyên môn"
  },
  "loading": {
    "details": "Đang tải thông tin nhân viên..."
  },
  "misc": {
    "notAvailable": "—",
    "scheduleNotConfigured": "Chưa cấu hình lịch làm việc",
    "notFound": "Không tìm thấy nhân viên",
    "notAssigned": "Chưa phân công",
    "unknown": "Không rõ"
  },
  "departmentCatalog": {
    "pages": {
      "title": "Phòng ban",
      "permissionDenied": "Bạn không có quyền xem danh mục phòng ban."
    },
    "actions": {
      "add": "Thêm phòng ban",
      "history": "Lịch sử"
    },
    "search": {
      "placeholder": "Tìm phòng ban..."
    },
    "filters": {
      "title": "Bộ lọc phòng ban",
      "status": "Trạng thái",
      "selectStatus": "Chọn trạng thái",
      "allStatuses": "Tất cả trạng thái"
    },
    "fields": {
      "name": "Phòng ban",
      "code": "Mã phòng ban",
      "isSystem": "Phòng ban hệ thống",
      "status": "Trạng thái",
      "staffCount": "Nhân viên",
      "createdAt": "Ngày tạo",
      "createdBy": "Người tạo",
      "updatedAt": "Ngày chỉnh sửa",
      "updatedBy": "Người chỉnh sửa",
      "leaveApprovers": "Người duyệt phép",
      "leaveFollowers": "Người theo dõi phép",
      "payrollApprovers": "Người duyệt tạm ứng",
      "payrollFollowers": "Người theo dõi tạm ứng",
      "attendanceApprovers": "Người duyệt chấm công"
    },
    "form": {
      "name": "Tên phòng ban",
      "namePlaceholder": "Nhập tên phòng ban",
      "leaveApproversHelper": "Mặc định cho nhân viên trong phòng ban khi hồ sơ không gán riêng. Người đầu tiên là mặc định.",
      "leaveFollowersHelper": "Mặc định theo dõi đơn phép của nhân viên trong phòng ban. Cộng dồn với gán trên hồ sơ nhân viên.",
      "payrollApproversHelper": "Mặc định duyệt đơn xin tạm ứng của nhân viên trong phòng ban khi hồ sơ không gán riêng.",
      "payrollFollowersHelper": "Mặc định theo dõi đơn xin tạm ứng của nhân viên trong phòng ban. Cộng dồn với gán trên hồ sơ nhân viên.",
      "attendanceApproversHelper": "Mặc định duyệt đơn điều chỉnh chấm công của nhân viên trong phòng ban khi hồ sơ không gán riêng."
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "history": {
      "title": "Lịch sử phòng ban",
      "empty": "Chưa có thay đổi nào trên phòng ban này."
    },
    "dialogs": {
      "addTitle": "Thêm phòng ban",
      "editTitle": "Sửa phòng ban",
      "deactivateTitle": "Ngừng dùng phòng ban",
      "deactivateMessage": "Ngừng dùng \"{{name}}\"? Nhân viên hiện tại ({{count}}) vẫn giữ phòng ban này; form mới không chọn được phòng ban đã ngừng dùng.",
      "deactivateConfirm": "Ngừng dùng"
    },
    "table": {
      "empty": "Chưa có phòng ban",
      "noFound": "Không tìm thấy phòng ban phù hợp"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên phòng ban",
      "nameTooLong": "Tên phòng ban không được quá {{max}} ký tự"
    },
    "toasts": {
      "created": "Đã thêm phòng ban",
      "updated": "Đã cập nhật phòng ban",
      "deactivated": "Đã ngừng dùng phòng ban",
      "saveFailed": "Không lưu được phòng ban",
      "deactivateFailed": "Không ngừng dùng được phòng ban",
      "loadFailed": "Không tải được danh mục phòng ban"
    }
  },
  "details": {
    "joined": "Vào làm {{date}}",
    "lastClockedIn": "Chấm công gần nhất",
    "lastClockedInEmpty": "Chưa chấm công",
    "linkedLoginAccount": "Đã liên kết tài khoản",
    "profileTabsAria": "các tab hồ sơ nhân viên",
    "applyWeeklyTemplateHint": "Vào tab Mẫu lịch để gán mẫu cho nhân viên này.",
    "contactManagerScheduleHint": "Liên hệ quản lý để thiết lập lịch làm việc.",
    "scheduleEffectiveFrom": " — Từ {{date}} — đang áp dụng",
    "scheduleChangeHint": " — muốn đổi lịch, gán lại mẫu lịch và bật ghi đè.",
    "basedAt": "Cơ sở: {{clinics}}",
    "scheduleClinic": "Chi nhánh",
    "scheduleForClinic": "Lịch theo chi nhánh: {{clinic}}",
    "noClinicForSchedule": "Nhân viên chưa được gán chi nhánh chính — không thể xem lịch làm việc.",
    "noEmergencyContact": "Chưa có liên hệ khẩn cấp.",
    "activityTitle": "Lịch sử hoạt động",
    "activityEmpty": "Chưa có hoạt động nào liên quan đến nhân viên này.",
    "attendanceEmpty": "Chưa có bản ghi chấm công.",
    "attendanceTitle": "Bảng chấm công",
    "timeOffEmpty": "Chưa có đơn nghỉ phép.",
    "attendanceScopedAway": "Bạn chỉ xem được chấm công của chính mình. Mở hồ sơ nhân viên gắn với tài khoản của bạn, hoặc cần quyền quản lý chấm công để xem nhân viên khác.",
    "timeOffScopedAway": "Bạn chỉ xem được nghỉ phép của chính mình. Mở hồ sơ nhân viên gắn với tài khoản của bạn, hoặc cần quyền quản lý lịch để xem nhân viên khác.",
    "showingRecent": "Đang hiện {{shown}} / {{total}} bản ghi gần nhất."
  },
  "me": {
    "noStaffProfile": "Tài khoản chưa được gắn hồ sơ nhân sự. Liên hệ quản trị viên.",
    "noAccess": "Bạn chưa có quyền truy cập khu vực Của tôi.",
    "profile": "Hồ sơ của tôi",
    "openFullProfile": "Mở hồ sơ đầy đủ",
    "attendanceHistory": "Lịch sử chấm công của tôi",
    "timeOff": "Nghỉ phép của tôi",
    "mySchedule": "Lịch làm việc của tôi",
    "scheduleClinicLabel": "Chi nhánh: {{clinic}}",
    "scheduleNoClinic": "Chưa có chi nhánh để xem lịch. Chọn phòng khám trên AppBar hoặc gắn chi nhánh chính cho hồ sơ nhân sự.",
    "scheduleLoadFailed": "Không tải được lịch làm việc.",
    "scheduleEmpty": "Không có dữ liệu lịch trong tuần này."
  }
}
